import React from "react";
import { useEffect, useRef } from "react";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

import { MissingInventoryViewModel } from "../../viewmodels/missingInventory/MissingInventoryViewModel";

const MissingInventory = (props) => {
  const { logout } = props;

  const {
    getMissingInventory,
    products,
    loading,
    emptyModal,
    getWarehouseLocations,
    getClassTypes,
    getCategoryTypes,
  } = MissingInventoryViewModel(logout);

  useEffect(() => {
    getMissingInventory();
    getWarehouseLocations();
    getClassTypes();
    getCategoryTypes();
  }, []);

  const searchRef = useRef();

  const handleSearch = () => {
    getMissingInventory(searchRef.current.value);
  };
  const bodyProductName = (item) => {
    return (
      <div>
        {item.product_name} <br />{" "}
        <span className="font-bold">PLU: {item.plu}</span>
      </div>
    );
  };

  const subItemWeightData = (item) => {
    return (
      <p>
        {item.on_hand_net_kg} kg <br />
        {item.on_hand_net_lbs} lbs
      </p>
    );
  };

  const subItemPiecesData = (item) => {
    return <p>{item.on_hand_piece_count} pieces</p>;
  };

  return (
    <div>
      <div className="mt-2">
        <div className="px-4 sm:px-6 lg:px-8">
          <div className="sm:flex sm:items-center px-4 py-2 sm:px-4 card-custom">
            <div className="sm:flex-auto">
              <h1 className="text-base font-semibold leading-6 text-gray-900">
                Missing inventory
              </h1>
              <div className="mt-5 flex rounded-md">
                <div className="relative flex items-stretch flex-grow focus-within:z-10">
                  <input
                    type="search"
                    name="searchCycleCount"
                    id="searchCycleCount"
                    className="block w-full rounded-lg rounded-l-md pl-2 sm:text-sm border border-gray-300 rounded-tr-none rounded-br-none"
                    placeholder="Search by cycle number"
                    ref={searchRef}
                    onKeyDown={(e) =>
                      e.key === "Enter" ? handleSearch() : null
                    }
                  />
                </div>
                <button
                  type="button"
                  className="-ml-px relative inline-flex items-center space-x-2 px-4 py-2 border border-gray-300 text-sm font-medium rounded-r-md text-gray-700 bg-gray-50 hover:bg-gray-100 focus:outline-none focus:ring-1"
                  onClick={() => handleSearch()}
                >
                  <MagnifyingGlassIcon
                    className="h-5 w-5 text-gray-400"
                    aria-hidden="true"
                  />
                </button>
              </div>
            </div>
          </div>
          <div className="mt-8 flow-root">
            <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
              <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                {loading ? (
                  <div>
                    <div className="border h-10 shadow rounded-md p-4 w-full mx-auto">
                      <div className="animate-pulse flex space-x-4">
                        Loading
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="overflow-hidden card-custom">
                    <DataTable
                      value={products}
                      dataKey="id"
                      tableClassName="min-w-full bg-white divide-y divide-gray-300 text-sm missing-items-table"
                      cellClassName="p-2 border-1-bottom-gray text-sm"
                    >
                      <Column
                        header="Product Name"
                        body={bodyProductName}
                        style={{ width: "15%" }}
                      />
                      <Column
                        field="lot_number"
                        header="Lot Number"
                        style={{ width: "10%" }}
                      />
                      <Column
                        field="barcode"
                        header="Barcode"
                        style={{ width: "20%" }}
                      />
                      <Column
                        header="Weight"
                        body={subItemWeightData}
                        style={{ width: "10%", textAlign: "right" }}
                      />
                      <Column
                        header="Piece count"
                        body={subItemPiecesData}
                        style={{ width: "10%", textAlign: "right" }}
                      />
                      <Column
                        field="warehouse_location_name"
                        header="Location"
                        style={{ width: "10%" }}
                      />
                    </DataTable>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MissingInventory;
